export const PERFORMANCE_LAB_NAV_PATHS = {
  diagnostics: '/performance-lab',
  recovery: '/performance-lab/recovery',
  ivLounge: '/performance-lab/iv-lounge',
  glp: '/performance-lab/glp',
  contact: '/performance-lab/contact',
} as const;

export type PerformanceLabNavSection = keyof typeof PERFORMANCE_LAB_NAV_PATHS;

const PERFORMANCE_LAB_NAVBAR_PATHS: readonly string[] = [
  PERFORMANCE_LAB_NAV_PATHS.diagnostics,
  PERFORMANCE_LAB_NAV_PATHS.recovery,
  PERFORMANCE_LAB_NAV_PATHS.ivLounge,
  PERFORMANCE_LAB_NAV_PATHS.glp,
  PERFORMANCE_LAB_NAV_PATHS.contact,
];

export const usesPerformanceLabNavbar = (pathname: string) =>
  PERFORMANCE_LAB_NAVBAR_PATHS.includes(pathname);

/** Strip query/hash, trailing slash, and region prefix for route comparisons. */
export function normalizePerformanceLabRoutePath(url: string): string {
  const path = url.split('?')[0].split('#')[0].replace(/\/$/, '') || '/';
  const plIndex = path.indexOf('/performance-lab');
  if (plIndex >= 0) {
    return path.slice(plIndex) || PERFORMANCE_LAB_NAV_PATHS.diagnostics;
  }
  return path;
}

export const usesPerformanceLabNavbarUrl = (url: string) =>
  usesPerformanceLabNavbar(normalizePerformanceLabRoutePath(url));

export const isPerformanceLabRoute = (pathname: string) =>
  normalizePerformanceLabRoutePath(pathname).startsWith('/performance-lab');

export const getPerformanceLabNavSection = (
  pathname: string,
): PerformanceLabNavSection | null => {
  if (pathname === PERFORMANCE_LAB_NAV_PATHS.diagnostics) return 'diagnostics';
  if (pathname === PERFORMANCE_LAB_NAV_PATHS.recovery) return 'recovery';
  if (pathname === PERFORMANCE_LAB_NAV_PATHS.ivLounge) return 'ivLounge';
  if (pathname === PERFORMANCE_LAB_NAV_PATHS.glp) return 'glp';
  if (pathname === PERFORMANCE_LAB_NAV_PATHS.contact) return 'contact';
  return null;
};
